<template>
  <div class="vendor-trends-item-wrapper">
    <div class="dashboards-filters">
      <div class="dashboards-filters">
        <strong>{{ title }}</strong>
      </div>
      <div class="dashboards-filters dashboards-filters-date date-simple">
        <date-picker
          v-model="params.creation_date"
          format="D MMM"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
        ></date-picker>
      </div>

      <div class="dashboards-filters">
        <custom-switcher
          v-model="params.reportType"
          :options="reportTypesList"
          field-name="Name"
        />
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
    <template>
      <chart-constructor
      :options="chartOptions"
      />
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import props from './props';

export default Vue.extend({
  name: 'CompanyKpiMainItem',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'chart-constructor': () =>
      import('@/components/charts/chartConstructor/index.js'),
    'custom-switcher': () => import('@/components/selectors/switcher/index.vue'),
  },
  props: {
    ...props,
  },
  data: () => ({
    chartOptions: Object(),
  }),
  watch: {
    value: {
      handler() {
        this.redrawGraph();
      },
      deep: true,
    },
  },
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    genOptionsObject(series) {
      const categories = series.map((e) => e.name);
      return {
        chart: {
          type: 'column',
          height: 200,
        },
        title: {
          text: '',
        },
        xAxis: {
          opposite: true,
          categories,
        },
        yAxis: {
          visible: false,
        },
        plotOptions: {
          column: {
            color: '#434348',
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              formatter: function() {
                return this.point.data;
              },
              verticalAlign: 'center',
              style: {
                fontSize: '60px',
              },
            },
          },
        },
        tooltip: {
          formatter: function() {
            return `${this.x}: <b>${this.point.data}</b>`;
          },
        },
        legend: {
          enabled: false,
        },
        series,
      };
    },
    redrawGraph() {
      this.getData().then((series) => {
        this.chartOptions = this.genOptionsObject(series);
      });
    },
    // Impementing this methods in child components
    getData() {
      return new Promise((res) => {
        res(Array());
      });
    },
  },
  mounted() {
    this.redrawGraph();
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  margin-bottom: 50px;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto;

  &-date {
    margin-left: 40px;
  }
}
</style>
